import React from 'react';

import Link from 'elements/Link';

import { getOutputText } from 'utils/widget';

import messages from './messages';

export default function getComplaintText(info, { titleInLink = true } = {}) {
  const { complaint, description } = info;
  const complaintCode = complaint && complaint.code;
  const complaintDescription = complaint && complaint.description;
  const title = complaintCode && complaintDescription && (
    titleInLink ?
      <Link to="#" modifiers={['hoverCaret']}>
        {complaintCode} - {complaintDescription}
      </Link>
      :
      `${complaintCode} - ${complaintDescription}`
  );

  return {
    title: getOutputText(title, description ?
      messages.undefinedComplaintCode : messages.undefinedComplaint),
    content: (title || description) &&
      getOutputText(description, messages.undefinedComplaintDescription),
  };
}



// WEBPACK FOOTER //
// ./utils/complaint.js